export const ROLES = { ADMIN: "groupAdmin", MEMBER: "groupUser" };

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("userData") || "{}");
  } catch {
    return {};
  }
};

export const getUserRole = (user = getStoredUser()) => {
  const value = user?.userType || user?.role;
  return value === ROLES.ADMIN || value === "admin"
    ? ROLES.ADMIN
    : ROLES.MEMBER;
};

export const isAuthenticated = () =>
  Boolean(
    localStorage.getItem("accessToken") && localStorage.getItem("userData"),
  );

export const getRoleLabel = (role) =>
  role === ROLES.ADMIN ? "Group Admin" : "Member";
